import Vue from "vue";
import Vuex from "vuex";

import actions from "./Root/actions";
import mutations from "./Root/mutations";
import state from "./Root/state";

import customer from "./modules/Customer";
import deliveryRequest from "./modules/DeliveryRequest";
import designer from "./modules/Designer";
import invoice from "./modules/Invoice";
import manufacturer from "./modules/Manufacturer";
import receiptLog from "./modules/ReceiptLog";
import receiptLogDetail from "./modules/ReceiptLogDetail";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        customer,
        designer,
        deliveryRequest,
        manufacturer,
        receiptLog,
        receiptLogDetail,
        invoice,
    },
    state,
    mutations,
    actions,
    strict: process.env.NODE_ENV !== "production",
});
